import { makeInitialState } from '../reducer';

export function Auth({ state, payload, action }) {
  switch (action) {
    case 'LOGIN':
      return { ...state, Auth: { ...state.Auth, logged: payload } };
    case 'LOGOUT':
      let initialState = makeInitialState();
      initialState.Public = JSON.parse(JSON.stringify(state.Public));
      localStorage.clear();
      sessionStorage.clear();
      return {
        ...initialState,
        Auth: {
          ...state.Auth,
          logged: false,
        },
      };
    case 'SET_PROFILE':
      return {
        ...state,
        Auth: {
          ...state.Auth,
          profile: payload.profile,
          workspace: payload.workspace,
        },
      };
    default:
      return { ...state };
  }
}
